import { Component, Mixins } from 'vue-property-decorator';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';
import { State } from 'vuex-class';

@Component
export default class AppWijzigenZelf extends Mixins(AppHypotheekMixin) {
  @State(state => state.config.ppfInfoMailAddress)
  public ppfInfoMailAddress!: string;
  @State(state => state.config.ppfContactUrl)
  public ppfContactUrl!: string;
}
